import { EventDetail } from "@/mocks/eventDetails";

interface Props {
  event: EventDetail;
}

export default function EventInfo({ event }: Props) {
  const spotsPercent = Math.round(((event.totalSpots - event.spotsLeft) / event.totalSpots) * 100);

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-6 sticky top-24">
      {/* Price */}
      <div className="mb-5">
        <p className="text-gray-400 text-xs mb-1">活動費用</p>
        <p className="text-red-600 font-black text-2xl">{event.priceLabel}</p>
      </div>

      {/* Info List */}
      <div className="flex flex-col gap-3 mb-5">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-50 shrink-0">
            <i className="ri-calendar-line text-red-600 text-sm" />
          </div>
          <div>
            <p className="text-gray-400 text-xs">活動日期</p>
            <p className="text-gray-800 text-sm font-medium">
              {event.date}{event.endDate ? ` ～ ${event.endDate}` : ""}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-50 shrink-0">
            <i className="ri-map-pin-line text-red-600 text-sm" />
          </div>
          <div>
            <p className="text-gray-400 text-xs">活動地點</p>
            <p className="text-gray-800 text-sm font-medium">{event.location}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-50 shrink-0">
            <i className="ri-group-line text-red-600 text-sm" />
          </div>
          <div>
            <p className="text-gray-400 text-xs">剩餘名額</p>
            <p className="text-gray-800 text-sm font-medium">
              <span className="text-orange-500 font-bold">{event.spotsLeft}</span> / {event.totalSpots} 人
            </p>
          </div>
        </div>
      </div>

      {/* Spots Progress */}
      <div className="mb-5">
        <div className="flex justify-between text-xs text-gray-400 mb-1.5">
          <span>報名進度</span>
          <span>{spotsPercent}% 已額滿</span>
        </div>
        <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-red-500 rounded-full transition-all duration-500"
            style={{ width: `${spotsPercent}%` }}
          />
        </div>
      </div>

      {/* CTA */}
      <a href="#registration-form">
        <button className="w-full py-3.5 rounded-full bg-red-600 text-white font-bold text-base hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap mb-3">
          立即報名
        </button>
      </a>
      <a
        href={event.contactLine}
        target="_blank"
        rel="nofollow noreferrer"
        className="w-full py-3 rounded-full border border-green-500 text-green-600 font-semibold text-sm hover:bg-green-50 transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
      >
        <i className="ri-line-fill" />
        加 LINE 詢問
      </a>

      {/* Tags */}
      <div className="flex flex-wrap gap-1.5 mt-5 pt-5 border-t border-gray-100">
        {event.tags.map((tag) => (
          <span key={tag} className="bg-stone-100 text-gray-500 text-xs px-2.5 py-1 rounded-full">
            #{tag}
          </span>
        ))}
      </div>
    </div>
  );
}
